import { AES_GCM_TAG_LENGTH_BITS } from '../constants';

import { getSubtleCrypto } from './subtle';

export async function importAesKey(
  rawKey: Uint8Array,
  usages: KeyUsage[],
): Promise<CryptoKey> {
  const subtle = getSubtleCrypto();
  return subtle.importKey('raw', rawKey as BufferSource, 'AES-GCM', false, usages);
}

export async function encryptAesGcm(
  key: CryptoKey,
  iv: Uint8Array,
  plaintext: Uint8Array,
  aad: Uint8Array,
): Promise<Uint8Array> {
  const subtle = getSubtleCrypto();
  const ciphertext = await subtle.encrypt(
    {
      name: 'AES-GCM',
      iv: iv as BufferSource,
      additionalData: aad as BufferSource,
      tagLength: AES_GCM_TAG_LENGTH_BITS,
    },
    key,
    plaintext as BufferSource,
  );
  return new Uint8Array(ciphertext);
}

export async function decryptAesGcm(
  key: CryptoKey,
  iv: Uint8Array,
  ciphertext: Uint8Array,
  aad: Uint8Array,
): Promise<Uint8Array> {
  const subtle = getSubtleCrypto();
  const plaintext = await subtle.decrypt(
    {
      name: 'AES-GCM',
      iv: iv as BufferSource,
      additionalData: aad as BufferSource,
      tagLength: AES_GCM_TAG_LENGTH_BITS,
    },
    key,
    ciphertext as BufferSource,
  );
  return new Uint8Array(plaintext);
}
